import React from 'react';
import { Link } from 'react-router-dom';
import { footerSiteLinks, legalLinks, ROUTES, socialLinks } from '../data/siteLinks';
import { CONSENT_SETTINGS_EVENT } from '../utils/analytics';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo-area">
          <Link to={ROUTES.home} className="footer-logo-link">Ayşegül Saraç</Link>
          <p className="footer-tagline">Almanya'ya Göç ve Yerleşim Rehberi</p>
        </div>

        <div className="footer-columns">
          <div className="footer-column">
            <h4>Site Haritası</h4>
            <ul>
              {footerSiteLinks.map((item) => (
                <li key={item.path}><Link to={item.path}>{item.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h4>Sosyal Medya</h4>
            <div className="footer-social-icons">
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href={socialLinks.google} target="_blank" rel="noopener noreferrer">Google</a>
            </div>
          </div>

          <div className="footer-column">
            <h4>İletişim</h4>
            <div className="footer-contact-item">
              <span className="footer-contact-label">Mail:</span>
              <a href="mailto:info@aysegulsarac.com">info@aysegulsarac.com</a>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-label">Telefon:</span>
              <a href="tel:+4915228301212">+49 15228301212</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            {legalLinks.map((item) => (
              <Link key={item.path} to={item.path}>{item.label}</Link>
            ))}
            <button
              type="button"
              className="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event(CONSENT_SETTINGS_EVENT))}
            >
              Cookie-Einstellungen
            </button>
          </div>
          <p className="footer-copyright">
            © {new Date().getFullYear()} Ayşegül Saraç, Köln. Tüm hakları saklıdır.
          </p>
        </div>

        <p className="footer-disclaimer">
          Ayşegül Saraç, taşınma ve bununla bağlantılı tüm süreçler hakkında bilgi ve raporlar sunmakta ve
          deneyimleriyle memnuniyetle yardımcı olmaktadır. Hukuki analiz, danışmanlık ve temsil gerektiren
          tüm işlemler, hukuk ortağımız Avukat Dr. Hayrullah Özcan tarafından yürütülmektedir.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
